import { fileSystem, isDesktop } from './fileSystem';
import * as Promise from 'bluebird';

export const galleryPhoto = () =>
  isDesktop()
    ? new Promise((success, reject) => {
        fileSystem()
          .chooseFile(['jpg', 'jpeg', 'png'])
          .then(file => fileSystem().readFile(file))
          .then(data => {
            const blob = new Blob([data]);
            const fileReader = new FileReader();
            fileReader.onload = event => {
              const Croppie = require('croppie');
              const fileReader = event.target;

              const croppiePhoto = document.createElement('div');
              croppiePhoto.style.position = 'absolute';
              croppiePhoto.style.top = -2000;
              croppiePhoto.style.left = -2000;
              document.body.appendChild(croppiePhoto);

              const imgCroppie = new Croppie(croppiePhoto, {
                viewport: {
                  width: 1024,
                  height: 1318,
                },
              });

              imgCroppie
                .bind({
                  url: fileReader.result,
                  zoom: 0,
                })
                .then(() => imgCroppie.result('base64'))
                .then(croppedData => {
                  const block = croppedData.split(';');
                  const dataType = block[0].split(':')[1];
                  const realData = block[1].split(',')[1];
                  imgCroppie.destroy();
                  croppiePhoto.parentNode.removeChild(croppiePhoto);
                  success({ realData, dataType });
                });
            };
            fileReader.onerror = error => console.log(error);
            fileReader.readAsDataURL(blob);
          });
      })
    : new Promise((success, reject) => {
        const Croppie = require('croppie');

        if (!navigator || !navigator.camera) {
          return reject('No camera available');
        }
        console.log('Entro aqui');
        navigator.camera.getPicture(
          imageData => {
            const croppiePhoto = document.createElement('div');
            croppiePhoto.style.position = 'absolute';
            croppiePhoto.style.top = -2000;
            croppiePhoto.style.left = -2000;
            document.body.appendChild(croppiePhoto);

            const imgCroppie = new Croppie(croppiePhoto, {
              viewport: {
                width: 1024,
                height: 1318,
              },
            });

            imgCroppie
              .bind({
                url: 'data:image/png;base64,' + imageData,
                zoom: 0,
              })
              .then(() => imgCroppie.result('base64'))
              .then(croppedData => {
                const block = croppedData.split(';');
                const dataType = block[0].split(':')[1];
                const realData = block[1].split(',')[1];
                imgCroppie.destroy();
                croppiePhoto.parentNode.removeChild(croppiePhoto);
                success({ realData, dataType });
              });
          },
          reject,
          {
            destinationType: Camera.DestinationType.DATA_URL,
            sourceType: Camera.PictureSourceType.PHOTOLIBRARY,
            targetWidth: 1024,
            targetHeight: 1318,
            correctOrientation: true,
          }
        );
      });
